import api from './client';

/**
 * Papel (cargo) — fonte ÚNICA das permissões de um usuário (RBAC puro).
 * Editar as permissões de um papel muda TODO MUNDO vinculado; o backend revoga
 * os tokens dos afetados pra a mudança valer em segundos, não no próximo login.
 */
export interface Papel {
  id: number;
  nome: string;
  descricao?: string | null;
  /** Papel base da instalação — editável, mas não excluível. */
  sistema: boolean;
  permissoes: string[];
  /** Quantos usuários dependem deste papel — a UI mostra o impacto antes de salvar/excluir. */
  qtdeUsuarios: number;
  atualizadoEm?: string | null;
  atualizadoPor?: string | null;
}

export interface SalvarPapelRequest {
  nome: string;
  descricao?: string | null;
  permissoes: string[];
}

interface Envelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class PapeisApi {
  async listar() {
    return api.get<Envelope<Papel[]>>('/papeis');
  }

  async obter(id: number) {
    return api.get<Envelope<Papel>>(`/papeis/${id}`);
  }

  async criar(data: SalvarPapelRequest) {
    return api.post<Envelope<Papel>>('/papeis', data);
  }

  async atualizar(id: number, data: SalvarPapelRequest) {
    return api.put<Envelope<Papel>>(`/papeis/${id}`, data);
  }

  async excluir(id: number) {
    return api.delete<{ success: boolean; message: string }>(`/papeis/${id}`);
  }

  /** Vincula o usuário a um papel. `null` desvincula (deixa sem acesso). */
  async atribuir(usuarioId: number, papelId: number | null) {
    return api.put<{ success: boolean; message: string }>(`/papeis/usuarios/${usuarioId}`, { papelId });
  }
}

export const papeisApi = new PapeisApi();
